(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5d6e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5d6e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1Fenh", function(module, exports) {

$parcel$export(module.exports, "ready", function () { return (parcelRequire("6X6nU")).ready; });

var $6X6nU = parcelRequire("6X6nU");

var $e9GSL = parcelRequire("e9GSL");
parcelRequire("iK3Hu");

});
parcelRegister("6X6nU", function(module, exports) {

$parcel$export(module.exports, "ready", function () { return $50fd34982b8395f2$export$28ee1007e174a2a6; });
/**
 * fn will be called when the DOM is ready
 * @param {Function} fn
 */ function $50fd34982b8395f2$export$28ee1007e174a2a6(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", ()=>fn());
}
function $50fd34982b8395f2$export$dbb304eeb4763ed() {
    return new Promise(function(resolve) {
        $50fd34982b8395f2$export$28ee1007e174a2a6(resolve);
    });
}
function $50fd34982b8395f2$export$3f65cefe8380dbea(element, eventType, handler, options) {
    element.addEventListener(eventType, handler, options);
    return ()=>{
        element.removeEventListener(eventType, handler, options);
    };
}

});

parcelRegister("e9GSL", function(module, exports) {
function $a4e32b81cc148292$export$b0b0be3404b52908(el, cb, delay = 2000) {
    let clicksCount = 0;
    let clickTimer;
    function handleTripleClick() {
        clicksCount++;
        if (clicksCount === 1) clickTimer = setTimeout(()=>{
            clicksCount = 0;
        }, delay);
        else if (clicksCount >= 3) {
            clearTimeout(clickTimer);
            clicksCount = 0;
            cb();
        }
    }
    el.addEventListener("click", handleTripleClick);
    return ()=>{
        el.removeEventListener("click", handleTripleClick);
    };
}

});

parcelRegister("iK3Hu", function(module, exports) {
function $da4f64ae79ed53ef$export$125915cfb610b3c2() {
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}

});


parcelRequire("1Fenh");
var $6X6nU = parcelRequire("6X6nU");
(0, $6X6nU.ready)(()=>{
    var _banner_querySelector;
    const banner = document.querySelector(".maintenance-banner");
    if (!banner) return;
    banner.addEventListener("transitionend", (event)=>{
        // remove the banner when the opacity transition ends
        if (event.propertyName === "opacity") banner.remove();
    }, {
        once: true
    });
    (_banner_querySelector = banner.querySelector(".dismiss-link")) === null || _banner_querySelector === void 0 ? void 0 : _banner_querySelector.addEventListener("click", ()=>{
        banner.classList.add("hidden");
    });
});

})();
//# sourceMappingURL=maintenance-banner.js.map
